/* VetroAqua Growth theme JS.
   Vine progress, sticky buy bar, and the scroll-scrubbed film sequence
   (ported from site/components/ScrollFilm.tsx to vanilla JS). */

(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- progress vine: grows with scroll, static full height under reduced motion ---------- */
  var vineFill = document.querySelector('[data-vine-fill]');
  if (vineFill) {
    if (reduce) {
      vineFill.style.height = '100%';
    } else {
      var vineTicking = false;
      var grow = function () {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var p = max > 0 ? Math.min(1, window.scrollY / max) : 1;
        vineFill.style.height = (p * 100) + '%';
        vineTicking = false;
      };
      window.addEventListener('scroll', function () {
        if (!vineTicking) { requestAnimationFrame(grow); vineTicking = true; }
      }, { passive: true });
      grow();
    }
  }

  /* ---------- sticky buy bar: appears after the hero, hides while the offer is visible ---------- */
  var hero = document.getElementById('hero');
  var offer = document.getElementById('offer');
  var bar = document.getElementById('buybar');
  if (bar && hero) {
    var pastHero = false;
    var offerVisible = false;
    var syncBar = function () {
      var show = pastHero && !offerVisible;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        pastHero = !entries[0].isIntersecting;
        syncBar();
      }, { threshold: 0 }).observe(hero);
      if (offer) {
        new IntersectionObserver(function (entries) {
          offerVisible = entries[0].isIntersecting;
          syncBar();
        }, { threshold: 0 }).observe(offer);
      }
    } else {
      pastHero = true;
      syncBar();
    }
  }

  /* ---------- scroll-scrubbed film sequence ---------- */
  var root = document.querySelector('[data-scroll-film]');
  if (!root) return;
  var pin = root.querySelector('[data-film-pin]');
  var canvas = root.querySelector('canvas');
  var framesEl = root.querySelector('[data-film-frames]');
  if (!pin || !canvas || !framesEl) return;
  var veil = pin.querySelector('[data-film-veil]');
  var fx = pin.querySelector('[data-film-fx]');
  var overlay = pin.querySelector('[data-film-overlay]');
  var archTop = pin.querySelector('[data-film-arch-top]');
  var archBottom = pin.querySelector('[data-film-arch-bottom]');

  var urls = [];
  try { urls = JSON.parse(framesEl.textContent); } catch (e) { urls = []; }
  var frameCount = urls.length;
  if (!frameCount) return;

  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var images = new Array(frameCount).fill(null);
  var loaded = new Array(frameCount).fill(false);
  var state = { frame: 0 };
  var rendered = -1;
  var anyLoaded = false;
  var cssW = 0;
  var cssH = 0;

  /* Themed skeleton shown before any frame is available. */
  function paintSkeleton() {
    var styles = getComputedStyle(document.documentElement);
    var a = (styles.getPropertyValue('--green-deep') || '#123c32').trim() || '#123c32';
    var b = (styles.getPropertyValue('--green') || '#1f5d4e').trim() || '#1f5d4e';
    var g = ctx.createLinearGradient(0, 0, cssW, cssH);
    g.addColorStop(0, a);
    g.addColorStop(1, b);
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, cssW, cssH);
  }

  /* Draw an image with object-fit cover semantics onto a w x h canvas area. */
  function drawCover(img, w, h) {
    var iw = img.naturalWidth || img.width;
    var ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var ir = iw / ih;
    var cr = w / h;
    var dw, dh;
    if (ir > cr) { dh = h; dw = h * ir; } else { dw = w; dh = w / ir; }
    ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
  }

  /* Nearest loaded frame at or before target, else nearest after. Missing frames are skipped. */
  function pickFrame(target) {
    if (loaded[target]) return images[target];
    for (var d = 1; d < frameCount; d++) {
      var lo = target - d;
      var hi = target + d;
      if (lo >= 0 && loaded[lo]) return images[lo];
      if (hi < frameCount && loaded[hi]) return images[hi];
    }
    return null;
  }

  function render(force) {
    var target = Math.max(0, Math.min(frameCount - 1, Math.round(state.frame)));
    if (!force && target === rendered) return;
    var img = pickFrame(target);
    if (!img) {
      if (!anyLoaded) paintSkeleton();
      return;
    }
    ctx.clearRect(0, 0, cssW, cssH);
    drawCover(img, cssW, cssH);
    rendered = target;
  }

  /* ---- intro/outro transition: focus-pull + curtain + mist over the first/last slice ---- */
  var INTRO = 0.12; /* fade the frame into focus over the first 12% of the scrub  */
  var OUTRO = 0.10; /* dissolve it back out over the last 10%                      */
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function smooth(x) { return x * x * (3 - 2 * x); }
  function applyEdge(p) {
    var intro = clamp01((INTRO - p) / INTRO);            /* 1 at top -> 0 by 12%  */
    var outro = clamp01((p - (1 - OUTRO)) / OUTRO);      /* 0 -> 1 into the finish */
    var introE = smooth(intro);
    var outroE = smooth(outro);
    var e = introE > outroE ? introE : outroE;
    if (e > 0.001) {
      canvas.style.filter = 'blur(' + (e * 12).toFixed(2) + 'px)';
      canvas.style.transform = 'scale(' + (1 + e * 0.05).toFixed(4) + ')';
    } else {
      canvas.style.filter = '';
      canvas.style.transform = '';
    }
    if (veil) veil.style.opacity = (e * 0.62).toFixed(3);
    if (fx) fx.style.opacity = (e * 0.8).toFixed(3);
    /* curved caps: top slides down as the film enters, bottom rises as it leaves;
       both fully off-screen (fullscreen frame) through the middle. */
    if (archTop) archTop.style.transform = 'translate(-50%,' + ((introE - 1) * 100).toFixed(2) + '%)';
    if (archBottom) archBottom.style.transform = 'translate(-50%,' + ((1 - outroE) * 100).toFixed(2) + '%)';
    if (overlay) overlay.style.opacity = (1 - e).toFixed(3); /* headline settles in on entry, clears on exit */
  }

  /* The pin fills the viewport via CSS (height:100dvh) and the canvas fills the
     pin (width/height:100%). dvh tracks the mobile dynamic viewport (address bar
     show/hide) on its own, so we do NOT force a pixel height here -- forcing one
     would go stale on iOS, where the bar toggle fires no window 'resize', leaving
     a green band under the film. We only (re)allocate the canvas backing store to
     match, and only when it actually changed (avoids thrash on toolbar toggles). */
  var lastBW = 0, lastBH = 0;
  function resize() {
    var rect = pin.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    cssW = rect.width;
    cssH = rect.height;
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var bw = Math.round(cssW * dpr), bh = Math.round(cssH * dpr);
    if (bw !== lastBW || bh !== lastBH) {
      canvas.width = bw;
      canvas.height = bh;
      lastBW = bw; lastBH = bh;
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    render(true);
  }

  function loadFrame(i) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        images[i] = img;
        loaded[i] = true;
        anyLoaded = true;
        if (Math.abs(i - Math.round(state.frame)) <= 1 || rendered === -1) {
          render(true);
        }
        resolve();
      };
      img.onerror = function () { resolve(); };
      img.src = urls[i];
    });
  }

  /* Concurrency-limited loader for frames after the poster. */
  function preloadRest() {
    var concurrency = 6;
    var next = 1;
    function worker() {
      if (next >= frameCount) return Promise.resolve();
      var i = next++;
      return loadFrame(i).then(worker);
    }
    var workers = [];
    for (var w = 0; w < Math.min(concurrency, frameCount); w++) workers.push(worker());
    return Promise.all(workers);
  }

  /* ---- scrubbing: a CSS-sticky pin driven by native scroll position.
     No pin-spacer and no plugin -- the pin fills the viewport via resize() and
     sticks with pure CSS, so it stays correct through any window resize. ---- */
  function clamp01b(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function sectionProgress() {
    var travel = root.offsetHeight - window.innerHeight; /* distance the pin stays stuck */
    if (travel <= 0) return 0;
    return clamp01b(-root.getBoundingClientRect().top / travel);
  }

  var scrubbing = false;
  var targetFrame = 0;
  var loopRAF = 0;
  function loop() {
    loopRAF = 0;
    var p = sectionProgress();
    targetFrame = p * (frameCount - 1);
    var diff = targetFrame - state.frame;
    if (Math.abs(diff) < 0.008) { state.frame = targetFrame; }
    else { state.frame += diff * 0.2; } /* light lerp for a smooth scrub */
    render();
    applyEdge(p);
    if (state.frame !== targetFrame) schedule();
  }
  function schedule() { if (!loopRAF) loopRAF = requestAnimationFrame(loop); }

  /* Debounced so a mobile address-bar toggle (which can fire a burst of resize
     events) doesn't thrash the canvas; the pin keeps filling via CSS meanwhile.
     resize always re-fits the canvas; only re-scrub if scrubbing is active (a
     reduced-motion poster must stay a clean, un-blurred frame). visualViewport
     catches iOS toolbar changes that don't fire a window 'resize'. */
  var resizeTimer = 0;
  function onViewportChange() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      resizeTimer = 0;
      resize();
      if (scrubbing) schedule();
    }, 150);
  }

  resize();
  paintSkeleton();
  window.addEventListener('resize', onViewportChange, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewportChange, { passive: true });
  }

  /* Poster first, then the rest, then wire up scrubbing. */
  loadFrame(0).then(function () {
    render(true);

    if (reduce) {
      /* Static poster only: never stretch the section, never scrub, no edge fx. */
      return;
    }

    applyEdge(0); /* pre-roll intro look before the first scroll */
    preloadRest();
    root.classList.add('is-scrub'); /* stretches the section so the sticky pin can travel */
    scrubbing = true;
    window.addEventListener('scroll', schedule, { passive: true });
    schedule(); /* paint at the current scroll position */
  });
})();
